exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.clusterDescriptionArea textarea[data-v-941bc894] {\n    line-height: 20px !important;\n    font-family: 'Roboto Mono', monospace !important;\n}\n\n", ""]);
